import { ValidationProvider } from 'vee-validate';
import { Component, Model, Prop } from 'vue-property-decorator';
import { ItiBaseEditor } from '../iti-base-editor';

@Component({
    components: {
        ValidationProvider,
    },
})
export default class ItiCheckbox extends ItiBaseEditor {

}
